import useBootstrapData from '@/hooks/useBootstrapData'
import { getRecentActivityData } from '@/components/RecentSearchCards/utils'
import { RecentSearchAndTripData } from '@/components/RecentSearchCards/types'
import useRecentActivity from './useRecentActivity'
import useRecentSearchCard from './useRecentSearchCard'
import useMostRecentFutureBooking from './useMostRecentFutureBooking'

const useRecentSearchAndTripData = (): RecentSearchAndTripData => {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn }
  } = useBootstrapData()

  const recentActivityResponse = useRecentActivity(
    clientGUID,
    {
      appName,
      appVersion
    },
    signedIn
  )
  const mostRecentFutureBooking = useMostRecentFutureBooking()
  const recentActivityData =
    recentActivityResponse !== null
      ? getRecentActivityData(recentActivityResponse)
      : null
  const showHotelSelection =
    recentActivityData !== null && !mostRecentFutureBooking

  const data = useRecentSearchCard(clientGUID, { appName, appVersion })
  const firstFiveCards = data.length > 5 ? data.slice(0, 5) : data

  return { recentActivityData, firstFiveCards, showHotelSelection }
}

export default useRecentSearchAndTripData
